import React, { useContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Button, Col, Row, Select, Table } from 'antd';
import { Context } from '../../../defaults';
import {
  getStudentExams,
  getFilteredSubjects,
  getFilteredExams,
  getFilteredMoreExams,
  getAllQuestionsById,
  getGroupById,
  getTopicsById,
  getTeacherById,
} from '../../../actions';
import moment from 'moment';
import { exportXls } from '.';

function Report(data) {
  return (
    <>
      <Button onClick={() => exportXls(data, 'student')}>
        Скачать отчет по выбранному экзамену
      </Button>
    </>
  );
}

const StudentsReport = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [subjects, setSubjects] = useState([]);
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState('');
  const [selectedMoreExam, setSelectedMoreExam] = useState('');
  const [questions, setQuestions] = useState([]);
  const [group, setGroup] = useState([]);
  const [teacher, setTeacher] = useState([]);
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    setLoading(true);
    const persistedToken = jwtDecode(localStorage['token']);
    const role = persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    role === 'student' &&
      getStudentExams().then(({ data }) => {
        const subjectsId = [];
        data.forEach((el) => {
          subjectsId.push(el.subjectId);
        });
        getFilteredSubjects([...new Set(subjectsId)]).then(({ data }) => setSubjects(data));
      });
    setLoading(false);
  }, []);

  const onSelectSubject = (value) => {
    setSelectedExam(null);
    setSelectedMoreExam(null);
    if (value) {
      getFilteredExams(value).then(({ data }) => setExams(data));
    }
  };

  const onSelectExam = (value) => {
    setSelectedExam(null);
    setSelectedMoreExam(null);
    if (value) {
      setSelectedExam(exams.filter((x) => x.id === value));
    }
  };

  const onSelectMoreExam = (id) => {
    if (id) {
      getFilteredMoreExams(id).then((res) => {
        setSelectedMoreExam([res.data]);
        getAllQuestionsById(res.data.studentExam.questionIds).then((res) => setQuestions(res.data));
        getGroupById(res.data.groupId).then((res) => setGroup([res.data]));
        getTopicsById(res.data.topicsId).then((res) => setTopics(res.data));
        getTeacherById(res.data.teacherId).then((res) => setTeacher([res.data]));
      });
    } else {
      setSelectedExam(null);
      setSelectedMoreExam(null);
    }
  };

  const columns = [
    {
      title: `${dictionary?.ExamName[language]}`,
      dataIndex: 'name',
      key: 'name',
      render: (text, { id }) => <a onClick={() => onSelectMoreExam(id)}>{text}</a>,
    },
    {
      title: `${dictionary?.ExamStartDate[language]}`,
      dataIndex: 'examDate',
      key: 'examDate',
      render: (examDate) => moment(examDate).format('L'),
    },
    {
      title: `${dictionary?.Subject[language]}`,
      dataIndex: 'subjectId',
      key: 'subjectId',
      render: (subjectId) => subjects && subjects.find((el) => el.id === subjectId)?.name,
    },
    {
      title: `${dictionary?.TotalPoint[language]}`,
      dataIndex: 'totalPoint',
      key: 'totalPoint',
      render: (e, e1, e2) => {
        return `${e1.totalPoint} / ${e1.maxTotalPoint}`;
      },
    },
  ];

  const columns2 = [
    {
      title: `${dictionary?.ClassroomTeacher[language]}`,
      dataIndex: 'teacherId',
      key: 'teacherId',
      render: (id) =>
        teacher &&
        teacher.find((el) => el.id === id)?.lastName +
          ' ' +
          teacher.find((el) => el.id === id)?.firstName +
          ' ' +
          teacher.find((el) => el.id === id)?.middleName,
    },
    {
      title: `${dictionary?.Group[language]}`,
      dataIndex: 'groupId',
      key: 'groupId',
      render: (id) => group && group.find((el) => el.id === id)?.name,
    },
    {
      title: `${dictionary?.Topic[language]}`,
      dataIndex: 'topicsId',
      key: 'topicsId',
      render: (topic) => (
        <>
          {topic.map((item) => {
            return <span key={item}>{topics && topics.find((el) => el.id === item)?.name},</span>;
          })}
        </>
      ),
    },
    {
      title: `${dictionary?.VariantNumber[language]}`,
      dataIndex: 'groupId + 1',
      key: 'groupId + 1',
      render: (e, e1, e2) => {
        return e1.studentExam.variantNumber;
      },
    },
  ];

  questions &&
    questions.length > 0 &&
    questions.forEach((el, index) => {
      columns2.push({
        title: `${dictionary?.Question[language]} ${index + 1}`,
        dataIndex: `questionId`,
        key: el.id,
        render: (e, e1, e2) => {
          return `${
            e1.studentExam.studentAnswers.find((item) => item.questionId === el.id)?.point
          } / ${el.point}`;
        },
      });
      if (index === questions.length - 1) {
        columns2.push({
          title: `${dictionary?.TotalPoint[language]}`,
          dataIndex: 'totalPoint',
          key: 'totalPoint',
          render: (e, e1, e2) => {
            return `${e1.studentExam.totalPoint} / ${e1.studentExam.maxTotalPoint}`;
          },
        });
      }
    });

  let exportData = {};
  const setData = () => {
    exportData = {
      column1: {
        examname: selectedMoreExam[0].name,
        examDate: moment(selectedMoreExam[0].examDate).format('L'),
        subject: subjects && subjects.find((el) => el.id === selectedMoreExam[0].subjectId)?.name,
        totalPoint: `${selectedMoreExam[0].studentExam.totalPoint} / ${selectedMoreExam[0].studentExam.maxTotalPoint}`,
      },
      column2: {
        teacher:
          teacher &&
          teacher.find((el) => el.id === selectedMoreExam[0].teacherId)?.lastName +
            ' ' +
            teacher.find((el) => el.id === selectedMoreExam[0].teacherId)?.firstName +
            ' ' +
            teacher.find((el) => el.id === selectedMoreExam[0].teacherId)?.middleName,
        group: group && group.find((el) => el.id === selectedMoreExam[0].groupId)?.name,
        topic: selectedMoreExam[0].topicsId.map((item) => {
          return topics && topics.find((el) => el.id === item)?.name;
        }),
        variantNumber: selectedMoreExam[0].studentExam.variantNumber,
        totalPoint: `${selectedMoreExam[0].studentExam.totalPoint} / ${selectedMoreExam[0].studentExam.maxTotalPoint}`,
        questions:
          questions &&
          questions.map((el) => {
            return `${
              selectedMoreExam[0].studentExam.studentAnswers.find(
                (item) => item.questionId === el.id,
              )?.point
            } / ${el.point}`;
          }),
      },
    };
  };

  selectedMoreExam && setData();

  return (
    <React.Fragment>
      <Row gutter={16}>
        <Col span={12}>
          <Select
            placeholder={dictionary?.Subject[language]}
            allowClear={true}
            showSearch
            style={{ width: '100%' }}
            onChange={(value) => onSelectSubject(value)}
            size="large"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {!!subjects &&
              subjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={`subject${el.id}`}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={12}>
          <Select
            placeholder={dictionary?.ExamName[language]}
            allowClear={true}
            showSearch
            style={{ width: '100%' }}
            onChange={(value) => onSelectExam(value)}
            size="large"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {!!exams &&
              exams.map((el) => {
                return (
                  <Select.Option value={el.id} key={`exam${el.id}`}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      {selectedExam && (
        <Table
          style={{ marginTop: 25, width: '100%' }}
          columns={columns}
          dataSource={selectedExam}
          bordered
          rowKey="id"
        />
      )}

      {selectedMoreExam && (
        <>
          <Table
            title={() => `${selectedExam[0].name}`}
            style={{ marginTop: 50, width: '100%' }}
            columns={columns2}
            dataSource={selectedMoreExam}
            bordered
            rowKey="id"
            scroll={{ x: '15px' }}
            pagination={false}
          />
          <br />
          <Report data={exportData} />
        </>
      )}
    </React.Fragment>
  );
};

export default StudentsReport;
